var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlecha(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9158 4.62594C20.0813 4.73628 20.1962 4.90783 20.2352 5.10287C20.2742 5.2979 20.2342 5.50044 20.1238 5.66594L11.1238 19.1659C11.0623 19.2582 10.981 19.3356 10.8859 19.3927C10.7908 19.4497 10.6842 19.485 10.5738 19.4959C10.4634 19.5068 10.352 19.4931 10.2476 19.4557C10.1431 19.4184 10.0483 19.3584 9.96985 19.2799L3.96985 13.2799C3.83737 13.1378 3.76524 12.9497 3.76867 12.7554C3.7721 12.5611 3.85081 12.3757 3.98822 12.2383C4.12564 12.1009 4.31102 12.0222 4.50532 12.0188C4.69963 12.0153 4.88767 12.0875 5.02985 12.2199L10.3828 17.5729L18.8758 4.83394C18.9862 4.66845 19.1577 4.55357 19.3528 4.51457C19.5478 4.47556 19.7503 4.51562 19.9158 4.62594Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecha);
export default __webpack_public_path__ + "static/media/flecha.0ae89ad88dc6a3951eae22205777e190.svg";
export { ForwardRef as ReactComponent };